import React, { useState } from "react";
import { array, func, string } from "prop-types";

import CrossIcon from "../../atoms/icons/cross-icon";
import RadioButton from "../../atoms/radiobutton";
import CheckBox from "../../atoms/checkbox";

import "./sortFilterPopupView.m.css";

const SortFilterPopupView = ({ sections, closePopupClick, updateSearchParams, sortItem, sectionIdList }) => {
  const [isSortSelected, setSortSelected] = useState(true);
  const sortItemList = [
    { text: "Newest First", value: "latest-published" },
    { text: "Oldest First", value: "published-at:asc" }
  ];

  const updateSortSelected = flag => () => setSortSelected(flag);

  // On Radio Change Event
  const onRadioButtonClick = e => {
    updateSearchParams("sort", e.target.value);
    closePopupClick();
  };

  // On Checkbox Item Selected Event
  const sectionItemChange = e => {
    let list = null;
    const id = parseInt(e.target.value);

    if (e.target.checked) {
      list = [...sectionIdList];
      list.push(id);
    } else {
      list = sectionIdList.filter(c => c !== id);
    }

    updateSearchParams("section", list);
    closePopupClick();
  };

  const getSortItemsView = () => (
    <div styleName="sort-items">
      {sortItemList.map((item, index) => (
        <RadioButton
          key={index}
          isChecked={sortItem === item.value}
          onClick={onRadioButtonClick}
          text={item.text}
          value={item.value}
        />
      ))}
    </div>
  );

  const getSectionItemsView = () => (
    <ul styleName="sort-items">
      {sections.map((item, index) => (
        <CheckBox
          key={index}
          type="type2"
          isHighlighting={true}
          isChecked={sectionIdList.includes(item.id)}
          onChange={sectionItemChange}
          text={item.title}
          value={item.id.toString()}
        />
      ))}
    </ul>
  );

  return (
    <div styleName="wrapper">
      <div styleName="title-with-close">
        <span styleName="title">SORT / FILTER</span>
        <div styleName="cross-icon" onClick={closePopupClick}>
          <CrossIcon width={18} height={18} />
        </div>
      </div>

      <div styleName="content">
        <div styleName="left">
          <div styleName="empty-div"></div>
          <div
            styleName={`sort-section-title ${isSortSelected ? "selected-item" : ""}`}
            onClick={updateSortSelected(true)}
          >
            Sort
          </div>
          <div
            styleName={`sort-section-title ${!isSortSelected ? "selected-item" : ""}`}
            onClick={updateSortSelected(false)}
          >
            Sections
          </div>
        </div>

        <div styleName="right">{isSortSelected ? getSortItemsView() : getSectionItemsView()}</div>
      </div>
    </div>
  );
};

SortFilterPopupView.propTypes = {
  sections: array,
  closePopupClick: func,
  sortItem: string,
  updateSearchParams: func,
  sectionIdList: array
};

export default SortFilterPopupView;
